export default __webpack_public_path__ + "static/pops-map-402b94c2a2782958dde75e7e519035e3.svg";